import toast from "react-hot-toast";
import { useEffect, useState } from "react";
//
import { useGetAllExportReportsMutation } from "../../../features/tenant/exportReportsApi/exportReportsApi";
//
import CustomExport from "../../../components/CustomExport/CustomExport";
import LinksComponent from "../../../components/Tenant/LinksComponent/LinksComponent";
import DataTableComponent from "../../../components/Tenant/DataTableComponent/DataTableComponent";

let inputClass =
    "block w-full pl-2 pr-3 border border-gray-300 rounded-lg bg-white text-sm placeholder-gray-500 focus:outline-none focus:ring-2 focus:ring-blue-500 focus:border-blue-500 transition-colors";

const fixed_types = [
    {
        name: "TDS",
        value: "tds",
    },
];

const statusTypes = {
    0: {
        label: "Deleted",
        className: "bg-grey-600 text-black px-2 py-1 rounded-full font-bold",
    },
    1: {
        label: "Completed",
        className: "bg-green-600 text-white px-2 py-1 rounded-full font-bold",
    },
    2: {
        label: "In Progress",
        className: "bg-blue-600 text-white px-2 py-1 rounded-full font-bold",
    },
    3: {
        label: "Failed",
        className: "bg-red-600 text-white px-2 py-1 rounded-full font-bold",
    },
};

const initialRequest = {
    report_type: "all",
    limit: 10,
    offset: 0,
    start_data: null,
    end_data: null,
};

const ExportReports = () => {
    const [page, setPage] = useState(1);
    const [limit, setLimit] = useState(10);
    const [allData, setAllData] = useState([]);
    const [csvData, setCsvData] = useState(null);
    const [request, setRequest] = useState(initialRequest);
    const [paginationData, setPaginationData] = useState({
        total_items: 0,
        current_page: 1,
        limit: 10,
        total_pages: 0,
    });

    const [
        getAllExportReports,
        { data: exportReportsData, error: exportReportsError },
    ] = useGetAllExportReportsMutation();

    const [
        getAllExportReportsCSV,
        { data: exportReportsCSVData, error: exportReportsCSVError },
    ] = useGetAllExportReportsMutation();

    const handleSearch = async (body) => {
        toast.loading("Please wait");

        if (body?.report_type === "all" || !body?.report_type) {
            delete body.report_type;
        }

        await getAllExportReports({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
            query: body,
        });

        toast.dismiss();
    };

    const handleFetchCSVData = async () => {
        const newRequest = { ...request };
        newRequest["limit"] = 9999999;
        newRequest["page"] = 1;

        getAllExportReportsCSV({
            token: sessionStorage.getItem("access_token"),
            tenant_id: JSON.parse(sessionStorage.getItem("vendorData"))
                .tenant_id,
            query: newRequest,
        });
    };

    const handlePageChange = (pageNumber) => {
        setPage(pageNumber);
        handleSearch({
            ...request,
            page: pageNumber,
            limit,
        });
    };

    const handlePerRowsChange = (newPerPage, page) => {
        setLimit(newPerPage);
        setPage(1);
        handleSearch({
            ...request,
            page: 1,
            limit: newPerPage,
        });
    };

    const intialize = () => {
        handleSearch({
            ...request,
            page,
            limit,
        });
    };

    useEffect(() => {
        if (exportReportsCSVData) {
            toast.dismiss();
            setCsvData(
                exportReportsCSVData?.body?.list
                    ? exportReportsCSVData?.body?.list
                    : [],
            );
        }

        if (exportReportsCSVError) {
            toast.dismiss();
            toast.error(exportReportsCSVError.data.message, {
                id: "exportReportsCSVError",
            });
        }
    }, [exportReportsCSVData, exportReportsCSVError]);

    useEffect(() => {
        if (exportReportsData) {
            toast.dismiss();

            setAllData(
                exportReportsData?.body?.list
                    ? exportReportsData?.body?.list
                    : [],
            );

            setPaginationData(
                exportReportsData?.body?.pagination
                    ? exportReportsData?.body?.pagination
                    : {},
            );
        }
        if (exportReportsError) {
            toast.dismiss();
            toast.error(exportReportsError.data.message, {
                id: "exportReportsError",
            });
        }
    }, [exportReportsData, exportReportsError]);

    useEffect(() => {
        intialize();
    }, []);

    const columns = [
        {
            name: "SNo",
            cell: (row, idx) => (page - 1) * limit + Number(idx + 1),
            sortable: true,
            width: "80px",
        },
        {
            name: "Type",
            cell: (row) => <strong>{row.report_type}</strong>,
            sortable: true,
            width: "120px",
        },
        {
            name: "Status",
            cell: (row) => (
                <>
                    <div className={`${statusTypes[row.status].className}`}>
                        {statusTypes[row.status].label}
                    </div>
                </>
            ),
            sortable: true,
            width: "160px",
        },
        {
            name: "File Link",
            cell: (row) =>
                row.report_link && (
                    <a
                        href={row.report_link}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {row.report_link}
                    </a>
                ),
            sortable: true,
            width: "500px",
        },

        {
            name: "Error Message",
            cell: (row) => row.error_message,
            sortable: true,
            width: "240px",
        },
        {
            name: "Generated By",
            cell: (row) => row.panel_user_name,
            sortable: true,
            width: "180px",
        },
        {
            name: "Completed On",
            cell: (row) =>
                new Date(row.completed_at).toLocaleString("en-IN", {
                    timeZone: "UTC",
                }),
            sortable: true,
            width: "180px",
        },
        {
            name: "Created At",
            cell: (row) =>
                new Date(row.created_at).toLocaleString("en-IN", {
                    timeZone: "UTC",
                }),
            sortable: true,
            width: "180px",
        },
    ];

    return (
        <>
            <div className="flex w-full bg-gray-200 h-full justify-center">
                <div className="w-full ">
                    <div className="border-b bg-white border-gray-300 pl-6 py-2 shadow-sm text-xl font-bold">
                        Export Reports
                        <LinksComponent />
                    </div>

                    <div className="p-3">
                        <div className="mb-3">
                            <CustomExport
                                fetchData={handleFetchCSVData}
                                data={csvData}
                                defaultColumnExport={[
                                    "file_link",
                                    "status",
                                    "completed_on",
                                    "created_at",
                                ]}
                                filename="export_reports"
                            />
                        </div>

                        <div className="p-3 w-full bg-white shadow rounded-lg">
                            <form
                                className="flex flex-row gap-4 w-full items-end justify-center p-2"
                                onSubmit={(e) => {
                                    e.preventDefault();
                                    setPage(1);
                                    handleSearch({
                                        ...request,
                                        page: 1,
                                        limit,
                                    });
                                }}
                            >
                                <div className="relative searchin w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Mobile
                                    </label>
                                    <input
                                        type="text"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="Mobile ..."
                                        value={request.mobile}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    mobile: newValue,
                                                };
                                            });
                                        }}
                                    />
                                </div>

                                <div className="relative searchin w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        User ID
                                    </label>
                                    <input
                                        type="text"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="User ID ..."
                                        value={request.user_id}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    user_id: newValue,
                                                };
                                            });
                                        }}
                                    />
                                </div>

                                <div className="relative searchin w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Product Code
                                    </label>
                                    <input
                                        type="text"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="Product Code..."
                                        value={request.product_code}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    product_code: newValue,
                                                };
                                            });
                                        }}
                                    />
                                </div>

                                <div className="space-y-2 w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Type
                                    </label>

                                    <select
                                        type="text"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="Type..."
                                        value={request.report_type}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    report_type: newValue,
                                                };
                                            });
                                        }}
                                    >
                                        <option value="all">All Types</option>
                                        {fixed_types?.map((item) => {
                                            return (
                                                <option value={item.value}>
                                                    {item.name}
                                                </option>
                                            );
                                        })}
                                    </select>
                                </div>

                                <div className="relative searchin w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        Start Date
                                    </label>
                                    <input
                                        type="date"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="Start Date ..."
                                        value={request.start_date}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    start_date: newValue,
                                                };
                                            });
                                        }}
                                    />
                                </div>

                                <div className="relative searchin w-full">
                                    <label className="block text-sm font-medium text-gray-700">
                                        End Date
                                    </label>
                                    <input
                                        type="date"
                                        id="default-search"
                                        className={`${inputClass}`}
                                        placeholder="End Date ..."
                                        value={request.end_date}
                                        onChange={(e) => {
                                            const newValue = e.target.value;
                                            setRequest((prevState) => {
                                                return {
                                                    ...prevState,
                                                    end_date: newValue,
                                                };
                                            });
                                        }}
                                    />
                                </div>

                                <div className="relative searchin">
                                    <button
                                        className="flex-1 bg-blue-600 hover:bg-blue-700 text-white font-medium py-2.5 px-4 rounded-lg transition-colors duration-200 flex items-center justify-center gap-2"
                                        type="submit"
                                    >
                                        <svg
                                            className="w-4 h-4"
                                            fill="none"
                                            stroke="currentColor"
                                            viewBox="0 0 24 24"
                                        >
                                            <path
                                                strokeLinecap="round"
                                                strokeLinejoin="round"
                                                strokeWidth={2}
                                                d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                                            />
                                        </svg>
                                        Search
                                    </button>
                                </div>
                            </form>

                            <DataTableComponent
                                keyField={(row) => row.SNo}
                                columns={columns}
                                data={allData}
                                // loading={loading}
                                totalRows={paginationData?.total_items}
                                handlePerRowsChange={handlePerRowsChange}
                                handlePageChange={handlePageChange}
                            >
                                <div className="flex m-2 space-x-2 justify-end"></div>
                            </DataTableComponent>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
};

export default ExportReports;
